import { useState, type FormEvent } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';

export default function AboutPage() {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormStatus('idle');
    setFormError('');

    const form = e.currentTarget;
    const formData = new FormData(form);

    const phoneAlt = (formData.get('phone_alt') as string || '').trim();
    if (phoneAlt) {
      setFormStatus('success');
      form.reset();
      return;
    }

    setSubmitting(true);

    try {
      const response = await fetch('https://readdy.ai/api/form/d9tfjln8l97n3eas390g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed: Record<string, unknown> | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        // not JSON
      }

      if (response.ok && parsed && (parsed as Record<string, string>).code === 'OK') {
        setFormStatus('success');
        form.reset();
      } else {
        const serverMsg = (parsed && (parsed as Record<string, Record<string, string>>).meta?.message)
          || (parsed && (parsed as Record<string, string>).message)
          || (parsed && (parsed as Record<string, Record<string, string>>).meta?.detail)
          || responseText
          || '提交失败，请稍后重试';
        if (serverMsg.includes('spam') || serverMsg.includes('form data is spam')) {
          setFormError('提交失败，请稍后重试');
        } else {
          setFormError(serverMsg);
        }
        setFormStatus('error');
      }
    } catch {
      setFormError('网络错误，请检查连接后重试');
      setFormStatus('error');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main className="min-h-screen pt-16">
        <div className="w-full px-4 md:px-6 py-10 bg-background-100">
          <div className="max-w-[800px] mx-auto">
            <Breadcrumb items={[{ label: '首页', to: '/' }, { label: '关于我们' }]} />
            <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mt-4">
              关于www91官方导航
            </h1>
          </div>
        </div>

        <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-50">
          <div className="max-w-[800px] mx-auto">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-6">
              品牌介绍
            </h2>
            <div className="text-foreground-700 leading-relaxed space-y-4 text-sm">
              <p>
                <strong>www91官方导航</strong>是www91平台官方认可的导航站点，致力于为广大用户提供最新、最准确的www91官方入口地址。自成立以来，我们始终坚持「安全、可靠、便捷」的服务理念，帮助数百万用户顺利访问www91平台。
              </p>
              <p>
                作为www91官方生态的重要组成部分，本导航站承担着入口引导和信息服务的双重职责。我们不仅实时更新官方入口地址，还提供详细的访问指南、使用教程和常见问题解答，确保每一位用户都能获得顺畅的访问体验。
              </p>
              <p>
                我们的团队由资深互联网从业者组成，深谙网络安全和用户体验之道。我们建立了完善的地址监控和更新机制，确保在入口地址发生变化时，能够第一时间响应并更新，让用户永远不会迷路。
              </p>
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
          <div className="max-w-[800px] mx-auto">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-6">
              信誉与承诺
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mb-8">
              <div className="bg-background-50 border border-background-200/70 rounded-xl p-6 text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-3">
                  <i className="ri-shield-star-line text-xl"></i>
                </div>
                <p className="font-heading font-semibold text-foreground-900 text-3xl mb-1">3年+</p>
                <p className="text-foreground-500 text-xs">稳定运营</p>
              </div>
              <div className="bg-background-50 border border-background-200/70 rounded-xl p-6 text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-3">
                  <i className="ri-user-heart-line text-xl"></i>
                </div>
                <p className="font-heading font-semibold text-foreground-900 text-3xl mb-1">50万+</p>
                <p className="text-foreground-500 text-xs">服务用户</p>
              </div>
              <div className="bg-background-50 border border-background-200/70 rounded-xl p-6 text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-600 mb-3">
                  <i className="ri-thumb-up-line text-xl"></i>
                </div>
                <p className="font-heading font-semibold text-foreground-900 text-3xl mb-1">99.8%</p>
                <p className="text-foreground-500 text-xs">用户满意度</p>
              </div>
            </div>
            <div className="text-foreground-700 leading-relaxed space-y-4 text-sm">
              <p>
                我们郑重承诺：本站提供的所有www91入口地址均经过官方验证，绝不存在诱导跳转、恶意软件或钓鱼风险。您的安全始终是我们的首要考量。
              </p>
              <p>
                本站为纯导航服务站点，不收集用户个人信息，不存储浏览数据，不植入任何跟踪代码。您通过本站访问www91平台的过程中，不会产生任何额外的隐私风险。
              </p>
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-50">
          <div className="max-w-[800px] mx-auto">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-6">
              联系我们
            </h2>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              <div>
                <p className="text-foreground-700 text-sm leading-relaxed mb-6">
                  如果您有任何关于www91访问的问题、建议或反馈，欢迎通过以下方式联系我们，或填写右侧表单，我们会在24小时内回复。
                </p>
                <div className="flex flex-col gap-4">
                  <div className="flex items-start gap-3">
                    <div className="w-9 h-9 flex-shrink-0 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                      <i className="ri-mail-line"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-500 mb-0.5">电子邮箱</p>
                      <p className="text-sm text-foreground-800 font-medium">support@www91-navigation.com</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-9 h-9 flex-shrink-0 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600">
                      <i className="ri-global-line"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-500 mb-0.5">官方网站</p>
                      <p className="text-sm text-foreground-800 font-medium">guifeizaixian.cn</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-9 h-9 flex-shrink-0 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                      <i className="ri-time-line"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-500 mb-0.5">服务时间</p>
                      <p className="text-sm text-foreground-800 font-medium">7×24小时全天候服务</p>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <form
                  data-readdy-form
                  id="contact-form"
                  onSubmit={handleSubmit}
                  className="bg-background-100 border border-background-200/70 rounded-xl p-6"
                >
                  <div className="flex flex-col gap-4">
                    <div>
                      <label htmlFor="name" className="block text-xs font-medium text-foreground-700 mb-1.5">
                        姓名 <span className="text-accent-600">*</span>
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        required
                        className="w-full px-3.5 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                        placeholder="请输入您的姓名"
                      />
                    </div>
                    <div>
                      <label htmlFor="email" className="block text-xs font-medium text-foreground-700 mb-1.5">
                        邮箱 <span className="text-accent-600">*</span>
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        required
                        className="w-full px-3.5 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                        placeholder="请输入您的邮箱"
                      />
                    </div>
                    <div>
                      <label htmlFor="subject" className="block text-xs font-medium text-foreground-700 mb-1.5">
                        主题
                      </label>
                      <input
                        type="text"
                        id="subject"
                        name="subject"
                        className="w-full px-3.5 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                        placeholder="请输入主题"
                      />
                    </div>
                    <div>
                      <label htmlFor="message" className="block text-xs font-medium text-foreground-700 mb-1.5">
                        留言内容 <span className="text-accent-600">*</span>
                      </label>
                      <textarea
                        id="message"
                        name="message"
                        required
                        rows={4}
                        maxLength={500}
                        className="w-full px-3.5 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors resize-none"
                        placeholder="请输入您的留言内容，最多500字"
                      ></textarea>
                      <p className="text-xs text-foreground-400 mt-1">最多500个字符</p>
                    </div>
                    <div className="spam-field">
                      <input
                        type="text"
                        name="phone_alt"
                        tabIndex={-1}
                        autoComplete="off"
                        aria-hidden="true"
                        readOnly
                      />
                    </div>
                    <button
                      type="submit"
                      disabled={submitting}
                      className="w-full py-2.5 rounded-lg bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm transition-colors disabled:opacity-60 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap"
                    >
                      {submitting ? (
                        <span className="flex items-center justify-center gap-2">
                          <i className="ri-loader-4-line animate-spin w-4 h-4 flex items-center justify-center"></i>
                          提交中...
                        </span>
                      ) : (
                        '发送消息'
                      )}
                    </button>
                    {formStatus === 'success' && (
                      <p className="text-sm text-center py-2 px-4 rounded-lg bg-accent-50 text-accent-700 font-medium">
                        感谢您的留言！我们会尽快回复。
                      </p>
                    )}
                    {formStatus === 'error' && (
                      <p className="text-sm text-center py-2 px-4 rounded-lg bg-red-50 text-red-600 font-medium">
                        {formError}
                      </p>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'AboutPage',
              name: '关于www91官方导航',
              description: 'www91官方导航是www91平台官方认可的导航站点，提供最新官方入口地址和访问指南。',
              url: 'https://guifeizaixian.cn/about',
              breadcrumb: {
                '@type': 'BreadcrumbList',
                itemListElement: [
                  {
                    '@type': 'ListItem',
                    position: 1,
                    name: '首页',
                    item: 'https://guifeizaixian.cn/',
                  },
                  {
                    '@type': 'ListItem',
                    position: 2,
                    name: '关于我们',
                  },
                ],
              },
            }),
          }}
        />
      </main>
      <Footer />
    </>
  );
}